import React from "react";
import { AuthLayout } from "@components/layouts/AuthLayout/AuthLayout";
import { sentryCreateBrowserRouter } from "@/sentry";

const CustomerDebtLoginPage = React.lazy(() =>
  import("@pages/CustomerDebtLoginPage/CustomerDebtLoginPage").then(
    (module) => ({
      default: module.CustomerDebtLoginPage,
    }),
  ),
);

export const debtModeRouter = () => {
  return sentryCreateBrowserRouter([
    {
      element: <AuthLayout />,
      children: [
        {
          path: "*",
          element: (
            <React.Suspense fallback={<></>}>
              <CustomerDebtLoginPage />
            </React.Suspense>
          ),
        },
      ],
    },
  ]);
};
